import { useCustomQuery } from "@/shared/hooks/useCustomQuery";
import PresetService, { GetPresetsParams, IPreset } from "../services/presets/presetService";
import { UseQueryOptions } from "@tanstack/react-query";
import { PaginatedResponse } from "@/features/profiles/services/profiles/types";

export const usePresetsData = (
  params: GetPresetsParams = {},
  options?: Omit<UseQueryOptions<PaginatedResponse<IPreset>>, "queryKey" | "queryFn">
) => {
  return useCustomQuery({
    serviceInstance: PresetService.Instance,
    selectAction: (service) => service.getPresets,
    parameter: params,
    options,
  });
};

